<template>
  <LKRoadmapsFeedModalContainer
    v-if="isActive"
    content-class="LKPublicationsFormdataModal"
    @close="close"
  >
    <LKPublicationsFormdataForm
      v-if="isActive"
      :form-template-id="formTemplate.id"
      :name="formTemplate.name"
      :sheets="sheets"
      :data-collection="dataCollectionLocal"
      :data-prefilled="prefilledData"
      :with-draft="withDraft"
      :readonly="readonly"
      :can-edit="canEdit"
      :use-excel="formTemplate.use_excel"
      :rev-date="revDate"
      style="max-height: 100%; overflow: auto;"
      @draft:clear="onReset"
      @close="onCancel"
      @submit="onSubmit"
      @input="v => dataCollectionLocal = v"
    />
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import { StorageService } from '@/helpers/storage.service'
import { createSheetData, downloadDocument } from './createSheetData'
import { saveDraft, getDraft, getKey } from './LKPublicationsFormdataView.vue'

import LKRoadmapsFeedModalContainer from '@/views/LKRoadmapsFeed/components/Modals/LKRoadmapsFeedModalContainer.vue'
import LKPublicationsFormdataForm from './components/LKPublicationsFormdataForm.vue'


const SAVE_DRAFT_TIMEOUT = 1_000 * 60 * 2

export default {
  name: 'LKPublicationsFormdataModal',
  components: {
    LKRoadmapsFeedModalContainer,
    LKPublicationsFormdataForm,
  },
  inheritAttrs: false,
  props: {
    dataCollection: {
      type: Object,
      validator: (prop) => (
        prop
        && 'data' in prop
      ),
    },
    formTemplate: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'name' in prop
        && 'sheets' in prop
      ),
    },
    resetOnClose: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
    canEdit: Boolean,
  },
  data: () => ({
    isActive: false,
    isLoadingAsyncData: false,
    withDraft: false,
    dataCollectionLocal: [],
    prefilledData: void 0,
  }),
  computed: {
    sheets() {
      return this.formTemplate.sheets
        .filter((_) => _.cells.length)
    },
    showExcelButtons() {
      return this.formTemplate.id ? this.excel : false
    },
    formDataId() {
      return this.dataCollection?.form_data_id ? this.dataCollection?.form_data_id : void 0
    },
    revDate() {
      return this.dataCollection?.created_at ? this.dataCollection?.created_at : void 0
    },
  },
  mounted() {
    this.intervalId = setInterval(
      this.onSaveDraft,
      SAVE_DRAFT_TIMEOUT,
    )
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
    if (this.resolve) this.close()
  },
  methods: {
    open() {
      this.onSetDataCollection()
      this.onSetPrefilledData()

      // ждем подгрузки стилей для анимации модалки
      setTimeout(() => { this.isActive = true }, 300)

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close() {
      this.isActive = false
      this.resolve()
      this.resolve = null
      this.$emit('closed')
      clearInterval(this.intervalId)
      if (this.resetOnClose) this.onReset()
    },
    onSetPrefilledData() {
      if (this.dataCollection?.prefill_data) {
        this.prefilledData = this.dataCollection?.prefill_data
      }
    },
    onSetDataCollection() {
      const dataCollection = (
        this.dataCollection?.data
        || getDraft(this.formTemplate.id)
      )

      if (dataCollection?.length) {
        this.dataCollectionLocal = dataCollection
        this.withDraft = true
        return
      }

      this.dataCollectionLocal = this.sheets
        .map(({ cells }) => createSheetData(cells))
    },
    onReset() {
      const id = getKey(this.formTemplate.id)
      StorageService.formDataDraft.remove(id)
      this.withDraft = false
      this.onSetDataCollection()
    },
    onSubmit() {
      downloadDocument(
        this.formTemplate,
        this.dataCollectionLocal,
      )
    },
    onSaveDraft() {
      this.withDraft = true
      saveDraft(
        this.formTemplate.id,
        null, null,
        this.dataCollectionLocal,
      )
    },
    onCancel() {
      this.close()
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKPublicationsFormdataModal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-width: calc(100% - #{2 * $modal-padding});
  max-height: calc(100% - #{2 * $modal-padding});
  margin: $modal-padding;
  overflow: none;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
</style>
